/**
 * Модуль для анимации элементов на странице
 */

import { load }   from '../system/load.js';

export let thema = {
    init: function() {
        thema.toggleElemen();

		thema.initQRcode();

        document.addEventListener('DOMContentLoaded', () => {
            const hash = window.location.hash;

            // нет якоря — выходим
            if (!hash) return;

            // убираем #
            const id = decodeURIComponent(hash.substring(1));
            const target = document.getElementById(id);

            // если элемента нет — выходим
            if (!target) return;

            const OFFSET_TOP = 200; // ← нужный отступ сверху, px

            // небольшая задержка, чтобы браузер не сделал мгновенный jump
            setTimeout(() => {
                const targetY =
                    target.getBoundingClientRect().top +
                    window.pageYOffset -
                    OFFSET_TOP;

                window.scrollTo({
                    top: Math.max(targetY, 0),
                    behavior: 'smooth'
                });
            }, 500);
        });
    },

	initQRcode: function() {
		if ($("[data-action='qrcode-publish']").length) {
			$(document).on("click", "[data-action='qrcode-publish']", function() {
				let _this = $(this),
					link = _this.data("href");

				load.get(link, (result) => {
					if (result.result === "success") {
						if (result.enabled === 1) {
							_this.text("Снять с публикации");
						} else {
							_this.text("Публиковать");
						}
						_this.attr("href", "/udata/users/switchCompanyDetailsBarcode/" + result.company_id + ".json?enabled=" + result.enabled);
					}
				});
			});
		}
	},

    /**
     * смена способа досавки
     */
    deliverychoose: function() {
        $(document).on("click", "input[name = 'delivery-id']", function() {
            $("label.shipping_type").removeClass("active");
            $('.delivery_tab > div.delivery_content_item').hide();

            let label = $(this).parent().find("label")
            let key = label.data('indx');

            label.addClass("active");
            $('#'+key).show();
        });
    },

    /**
     * Информационное окно после добавления в корзину
     * @param o
     */
    basket_inform: function(o) {
        const offerId = o?.options?.offer_id || null;
        const pageId = o?.id || null;
        const priceTypeId = o?.options?.price_type_id || null;
        let siteUrl = window.location.origin + window.location.pathname;

        let items = o?.data?.items || null;

        if (items) {
            for(let i = 0; i <= items.length; i++) {
                let item = items[i];
                const page = item?.page;
                if (page && page.id === pageId) {
                    siteUrl = page.link;
                }
            }
        }

        const action = siteUrl + '?ajax=1&type=addbusket&offer_id=' + offerId + '&price_type_id=' + priceTypeId;

        load.get(action, (result) => {
            $("#overlay").show();
            let popup = $("#add2cart");
            popup.html(result);
            popup.show();

            thema._placeContainerNearViewport( popup );
        }, "text");
    },

    /**
     * Покраска
     */
    init_cart_painter: function() {
        const painterCalcBlock = $(".painter-calc-block");

        painterCalcBlock.hide();

        // Блок: как считать покраску
        $(document).on("click", "[data-action='painter']", function() {
            painterCalcBlock.show();
        });

        // переход к расчету стоимости покраски
        $(document).on("click", "[data-action='painter-calc-btn']", function(e) {
            let $btn = $(this),
                link = $btn.data("href") || null;

            if (link) {
                window.location.href = link + "?#painter-calc";
            }
        });

        // расчет покраски менеджером
        $(document).on("click", "[data-action='to-checkout-2']", function(e) {
            let $btn = $(this),
                link = $btn.data("href") || null;

            load.get("/udata/emarket/painting_calculation_required/1.json", (result) => {
                window.location.href = link;
            });
        });

        // удаление пожелания про покраску
        $(document).on("click", "[data-action='painter-not-required']", function(e) {
            let $btn = $(this);
            load.get("/udata/emarket/painting_calculation_required/0.json", (result) => {
                $btn.parent().remove();
            });
        });

    },

    /**
     * Отслеживание события изменения стоимости корзины
     */
    init_min_cart_summary: function() {
        const selector = document.querySelector(".cart_summary_all");

        if (!selector) return;

        const observer = new MutationObserver(() => {
            thema.check_min_cart_summary();
        });

        observer.observe(selector, {
            childList: true,        // изменение текста
            characterData: true,    // замена текстовых нод
            subtree: true
        });

        // первый запуск
        thema.check_min_cart_summary();
    },

    /**
     * Показ/скрытие блока про минимальный заказ
     */
    check_min_cart_summary: function () {
        const $el = $(".cart_summary_all");
        if (!$el.length) return;

        // парсим "21 942 ₽" -> 21942
        const total = Number($el.text().replace(/[^\d]/g, "")) || 0;

        if (total >= 15000) {
            $(".checkout-btn").show();
            $("#min-cart-summary").hide();
        } else {
            $(".checkout-btn").hide();
            $("#min-cart-summary").show();
        }
    },

    /**
     * Открытие/закрытие блоков
     * Примеры data-target:
     *   self
     *   parent
     *   closest:.dropdown
     *   parents:.accordion
     *   #menu, .overlay, closest:.card, self
     */
    toggleElemen: function () {
        $(document).on("click", "[data-action='toggleelement']", function (e) {
            const $element = $(e.currentTarget);
            let target = $element.data("target");

            if (!target || typeof target !== "string") return false;

            // строка -> массив (поддержка "a, b, c")
            const targets = target
                .split(",")
                .map(t => t.trim())
                .filter(Boolean);

            targets.forEach(t => {
                // self — переключить open на самом элементе-триггере
                if (t === "self") {
                    $element.toggleClass("open");
                    return;
                }

                // parent — переключить open на родителе
                if (t === "parent") {
                    $element.parent().toggleClass("open");
                    return;
                }

                // parent:.selector — найти внутри родителя
                if (t.startsWith("parent:")) {
                    const selector = t.slice(7).trim();
                    if (selector) $element.parent().find(selector).toggleClass("open");
                    return;
                }

                // closest:.selector — ближайший предок по селектору
                if (t.startsWith("closest:")) {
                    const selector = t.slice(8).trim();
                    if (selector) $element.closest(selector).toggleClass("open");
                    return;
                }

                // parents:.selector — все предки по селектору
                if (t.startsWith("parents:")) {
                    const selector = t.slice(8).trim();
                    if (selector) $element.parents(selector).toggleClass("open");
                    return;
                }

                // обычный селектор (может быть "#id", ".class", "body .x" и т.д.)
                $(t).toggleClass("open");
            });

            return false;
        });
    },

    /**
     * Выставить top у контейнера так, чтобы он оказался "возле" пользователя
     * (примерно по центру текущей видимой области).
     *
     * Контейнер должен быть позиционирован через CSS (position: absolute или fixed),
     * иначе top не подействует.
     *
     * @param {JQuery} $container
     * @private
     */
    _placeContainerNearViewport: function ($container) {
        if (!$container || !$container.length) return;

        try {
            const $win = $(window);
            const scrollTop = $win.scrollTop() || $(document).scrollTop() || 0;
            const winH = $win.height() || 0;
            const contH = $container.outerHeight() || 0;

            let top;

            if (!winH || !contH) {
                // если не смогли измерить — просто чуть ниже текущего скролла
                top = scrollTop + 75;
            } else if (contH >= winH) {
                // форма выше экрана — прижимаем к верхней границе видимой области с небольшим отступом
                top = scrollTop + 75;
            } else {
                // нормальный случай — центр по вертикали
                top = scrollTop + (winH - contH) / 2;
            }

            if (top < 0) top = 50;

            $container.css('top', top + 'px');
        } catch (e) {
            // в худшем случае просто ничего не делаем
            if (window.console && console.warn) {
                console.warn('[contactForm] _placeContainerNearViewport error:', e);
            }
        }
    },
}

thema.init();
